export default __webpack_public_path__ + "static/media/fadil-novalic.2786f162.jpg";